module.exports = __webpack_public_path__ + "static/media/Digital Health Card.d633cf36.svg";